import { styled, CustomLink, Body } from '@teko/ds-foundation';
import React from 'react';

const StyledCustomLink = styled(CustomLink)(({ theme, disabled }) => `
  color: ${disabled ? theme.colors.textSecondary : theme.colors.link500};
  text-decoration: none;
  &:hover {
    color: ${theme.colors.link700};
  }
  ${disabled ? "pointer-events: none;" : ""}
`);
const BreadcrumbItem = ({
  name,
  link,
  disabled = false,
  isEndOfBread = false
}) => {
  return /* @__PURE__ */ React.createElement(StyledCustomLink, {
    href: link,
    passHref: true,
    disabled,
    className: "breadcrumb-item"
  }, /* @__PURE__ */ React.createElement(Label, {
    color: isEndOfBread ? "#000" : void 0,
    line: 1,
    level: 1
  }, name));
};
const Label = styled(Body)`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 17px;
`;

export { BreadcrumbItem };
